var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _vm._m(0)}
var staticRenderFns = [function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-flex align-center justify-center coming-soon"},[_c('div',{staticClass:"text-sm neutral500--text"},[_vm._v("Coming soon")])])}]

export { render, staticRenderFns }